document.addEventListener( 'DOMContentLoaded', function () {

    // Check if we are on the cart page from WooCommerce
    if ( !document.body.classList.contains( 'woocommerce-cart' ) ) {
        return;
    }

    // Fixes for the quantity field restrictions
    const quantityInputs = document.getElementsByClassName( 'quantity' );

    // For every inputfield quantity, create the eventlisteners
    Array.from( quantityInputs ).forEach( input => {

        // Prevents certain keys from being pressed in the quantity field
        input.addEventListener( 'keydown', function ( e ) {
            if ( ['.', '+', '-', 'e', ',', 'ArrowUp', 'ArrowDown'].includes( e.key ) || [ 190, 107, 109, 69, 38, 39 ].includes( e.keyCode ) ) {
                e.preventDefault();
            }
        });

        // Disable pasting of anything into the quantity fields
        input.addEventListener( 'paste', function ( e ) {
            e.preventDefault();
        });

        // Edit the field after deselect or delay
        input.addEventListener( 'input', function () {
            update_cart_with_delay( this );
        });
        input.addEventListener( 'change', function () {
            update_cart_with_delay( this );
        });
    });
});


/**
 * This should gather the new data, and update the backend with it. \
 * It also contains a delay so it can handle spam changes \
 */
function update_cart_with_delay( input ) {

    // Get the new quantity
    var new_quantity = input.children[ 0 ].children[ 1 ].value;

    // Check if the value is more than 0, otherwise dont set new values
    if( new_quantity > 0 ) {

        // Get the productkey, so we know where to update what
        product_div = input.parentNode.parentNode.parentNode.parentNode;
        product_key = product_div.getAttribute( "data-cart-item-key" );
    
        clearTimeout( input.delayTimer );
        // element = input;
        input.delayTimer = setTimeout( function () {

            // Updating the actual WooCommerce cart
            update_cart_quantity_backend( input, product_key, new_quantity );

        }, 1000); // The delay so it can handle spam changes
    } 
}


/**
 * Gets the new value from the input field \
 * Should set the cart_row, based on product_key, with a new quantity \
 * After that, recalculates and shows the new row_subtotal, cart_subtotal and cart_total
 */
function update_cart_quantity_backend( input, cart_item_key, newQuantity ) {
    if( newQuantity > 0 ) {

        fetch( ajax_object.ajax_url, {
            method: 'POST', // The request method
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded', // Content type
            },
            // Convert the data object to URL-encoded query string
            body: new URLSearchParams( {
                'action': 'update_cart_quantity', // Your action hook here
                'cart_item_key': cart_item_key, // Variable with cart item key
                'quantity': newQuantity, // Variable with new quantity
            } )
        } )
        .then ( response => {
            if ( !response.ok ) {
                throw new Error( 'Network response was not ok' );
            }
            return response.json(); // Parse JSON response
        } )
        .then ( dataResponse => {
            /**
             * Data expected in dataResponse from the call
             * dataResponse.data.message
             * dataResponse.data._quantity
             * dataResponse.data._packamount
             * dataResponse.data._priceunit
             * dataResponse.data._newRowPrice
             * dataResponse.data._newSubTotal
             * dataResponse.data._newTotal
            */
            update_cart_quantity_frontend( input, cart_item_key, dataResponse.data._quantity, dataResponse.data._packamount, dataResponse.data._priceunit );
            update_cart_item_subtotal( cart_item_key, dataResponse.data._newRowPrice );
            update_cart_subtotal( dataResponse.data._newSubTotal );
            update_cart_total( dataResponse.data._newTotal );
        } )
        .catch ( error => {
            console.error( 'Error:', error ); // When error is present, write the log
        } );
    }
}


/**
 * Sets the new package amount when needed. \
 * Also sets the new corresponding quantity in the input field.
 */
function update_cart_quantity_frontend( input, cart_item_key, newQuantity, newPackages, pricing ) {
    // Check if the package amount is more then 0
    if( newPackages == undefined ) {
        newPackages = 0;
    }
    
    // Update the value on the frontend
    input.children[0].children[1].value = Math.round( newQuantity );
    
    // Set the amount of packages

    // Unit is always pak, else it is build somewhere else
    var unit = "pak";
    if ( pricing == "Pakprijs" ) {
        var cart_item = document.querySelector( `div[data-cart-item-key="${cart_item_key}"]` );
        if( cart_item != "" ) {
            var cart_item_package_amount = cart_item.querySelector( '.pack .pack_amount' );
            if( cart_item_package_amount != null ) {
                // Set the new package amount in the component
                cart_item_package_amount.innerText = `${newPackages}`;
            }
        }
        
        if ( newPackages > 1 ) {
            unit += "ken"; 
        }
        cart_item.querySelector( '.pack .amount_unit' ).innerText = `${unit}`;
    }
}

/**
 * Sets the new subtotal for every item in the frontend. 
 * On page reload, the data from backend is loaded, should always be the same
 * Calculations are done with data from the backend
 */
function update_cart_item_subtotal( cart_item_key, newRowPrice ) {
    // Get the cart item
    var cart_item = document.querySelector( `div[data-cart-item-key="${cart_item_key}"]` );
    if( cart_item != "" ) {
        // Select the subtotal of the item, so we can update it 
        var cart_item_price = cart_item.querySelector( '.component .price .new .price-amount' );
        // If the subotal exists
        if( cart_item_price != null ) {
            // Update the cart item subtotal
            cart_item_price.innerText = `${newRowPrice}`;
        }
    }

}


/**
 * Sets the new subtotal for the full cart in the frontend. 
 * On page reload, the data from backend is loaded, should always be the same
 * Calculations are done with data from the backend
 */
function update_cart_subtotal( _newSubtotal ) {
    // Select the subtotal, so we can update it 
    var price_summation = document.querySelector( '.price-products-summation span.price-amount' );

    // Update the subtotal
    price_summation.innerText = `${_newSubtotal}`;
}


/**
 * Sets the new total for the full cart in the frontend. 
 * On page reload, the data from backend is loaded, should always be the same
 * Calculations are done with data from the backend
 */
function update_cart_total( _newTotal ) {
    // Select the total, so we can update it 
    var price_total = document.querySelector( '.price-total span.price-amount' );
    
    // Update the total
    price_total.innerText = `${_newTotal}`;
}
